import React from "react";

const CurrentOffice = ({ data }) => {
  const {
    office,
    legislative = [],
  } = data || {};

  if (!office) {
    return null;
  }

  return (
    <section
      className="legislative-section section-padding"
      id="legislative"
      aria-labelledby="legislative-title"
    >
      <div className="container">

        {/* =========================
            SECTION HEADING
        ========================== */}
        <div className="section-heading centered">

          <p className="section-label light">
            <span />
            CURRENT PUBLIC OFFICE
          </p>

          <h2 id="legislative-title">
            A voice for the people.
          </h2>

          <p>
            {office.position},{" "}
            {office.office}.
          </p>

        </div>

        {/* =========================
            LEGISLATIVE CARDS
        ========================== */}
        {legislative.length > 0 && (
          <div className="legislative-grid">

            {legislative.map((item, index) => (

              <article
                className={`legislative-card ${
                  item.featured ? "featured" : ""
                }`}
                key={item.id || item.number || index}
              >

                <div
                  className="card-icon"
                  aria-hidden="true"
                >
                  {item.icon}
                </div>

                <span>
                  {item.number ||
                    String(index + 1).padStart(2, "0")}
                </span>

                <h3>
                  {item.title}
                </h3>

                <p>
                  {item.text}
                </p>

                {item.link && (
                  <a href={item.link}>
                    {item.linkText || "Learn More →"}
                  </a>
                )}

              </article>

            ))}

          </div>
        )}

      </div>
    </section>
  );
};

export default CurrentOffice;